<ng-container *transloco="let t; read: 'user'">
<div class="fix-action-row modal-body">
  <div class="flex justify-between border-b">
    <h1 class="text-[25px] font-bold">
      {{ t('dashboard.pendingRequests.invalidRequest.title') }}
    </h1>
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
  </div>

  <div mat-dialog-content>
    <h1 class="mt-4">{{ t('dashboard.pendingRequests.invalidRequest.instructions') }}</h1>
    @if (invalidRequests.isInvalidRatingPeriod?.length > 0) {
      <h1 class="mt-4 font-bold">
        {{ t('dashboard.pendingRequests.invalidRequest.enrollmentPassed') }}
      </h1>
    }
    <div class="mt-2">
      <ul>
        @for (student of invalidRequests.isInvalidRatingPeriod; track student) {
          <li>
            - {{ student }}
          </li>
        }
      </ul>
    </div>
    @if (invalidRequests.isDomainMeasureMismatch?.length > 0) {
      <h1 class="mt-4 font-bold">
        {{ t('dashboard.pendingRequests.invalidRequest.domainMeasureMismatch') }}
      </h1>
    }
    <div class="mt-2">
      <ul>
        @for (student of invalidRequests.isDomainMeasureMismatch; track student) {
          <li>
            - {{ student }}
          </li>
        }
      </ul>
    </div>
  </div>
</div>

<div mat-dialog-actions class="flex justify-end">
  <drdp-btn class="ml-3" mat-button cdkFocusInitial mat-dialog-close>{{ t('dashboard.pendingRequests.actions.ok') }}</drdp-btn>
</div>
</ng-container>
